export default () => ({
  menuopen: false,
});
